module.exports = __webpack_public_path__ + "img/2.a99f1618.jpg";